module.exports = __webpack_public_path__ + "img/thumb-tiny-image-1.baf12c3b.png";